import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion } from '@mui/material';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Dialog from '@mui/material/Dialog';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import React, { FC, memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppState, useAppSelector } from 'src/store';
import { setDocumentDetail } from 'src/store/documentDetail';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import DocManagementService from '../documentUpload/service/DocManagementService';
import { EditMetaDataProps } from './types';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  }
}));

const MetricsDetails: FC<any> = ({
  expanded,
  accordionInfo,
  documentProps,
  fetchUpdatedData,
  handleToogleAccordion
}: EditMetaDataProps) => {
  const documentDetail: any = useSelector((state: AppState) => state.documentDetail);
  const { preferedDateFormat } = usePreferedDateFormat();
  const docService = new DocManagementService();
  const dispatch = useDispatch();
  const user: any = useAppSelector(state => state.user.user);
  const selectedStudy = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Study);
  const selectedCountry = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Country);
  const selectedSite = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Site);

  let TmfLevel =
    (selectedStudy === '--' || selectedStudy === '') &&
    (selectedCountry === '--' || selectedCountry == '') &&
    (selectedSite === '--' || selectedSite === '')
      ? '--'
      : (selectedCountry === '--' || selectedCountry == '') && (selectedSite === '--' || selectedSite === '')
      ? 'Study'
      : selectedSite === '--' && selectedCountry != '--'
      ? 'Country'
      : 'Site';
  if (TmfLevel === '--') {
    TmfLevel = 'Study';
  }

  function createData(name: string, value: string | null) {
    return { name, value };
  }
  const dateString = documentDetail?.data[0]?.tmf_doc_date;
  const date = preferedDateFormat(dateString);

  const data = {
    query_filters: [
      {
        name: 'tmf_document_id',
        value: documentDetail?.data[0]?.tmf_document_id,
        operation: 'equals'
      }
    ],
    filter_types: ['All']
  };

  const update = async () => {
    const params = {
      module_section_related: 'DocumentDetails',
      parent_entity_related: 'Metric Data'
    };
    const res = await docService.getGlobalSearch(data, selectedStudy, selectedCountry, selectedSite, TmfLevel, params);
    setDocumentDetail(dispatch, [
      {
        ...documentDetail.data[0],
        tmf_doc_viewer_approval_cycle: res?.data?.selected_data[0]?.document_data.tmf_doc_viewer_approval_cycle,
        tmf_doc_approval_date: res?.data?.selected_data[0]?.document_data.tmf_doc_approval_date,
        tmf_doc_approval_st_dt: res?.data?.selected_data[0]?.document_data.tmf_doc_approval_st_dt
      }
    ]);
  };

  useEffect(() => {
    update();
  }, [expanded]);

  const rows = [
    createData(
      'Approval Complete Date:',
      documentDetail.data[0] && preferedDateFormat(documentDetail.data[0].tmf_doc_approval_date)
    ),
    createData(
      'Approval  Start Date:',
      documentDetail.data[0] && preferedDateFormat(documentDetail.data[0].tmf_doc_approval_st_dt)
    ),
    createData('No of Approval Cycle:', documentDetail.data[0] && documentDetail.data[0].tmf_doc_viewer_approval_cycle),
    createData('Upload Date:', documentDetail.data[0] && preferedDateFormat(documentDetail.data[0].tmf_doc_date))
  ];

  return (
    <>
      <Accordion
        expanded={accordionInfo.position === expanded}
        onChange={handleToogleAccordion(accordionInfo.position)}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
          <Typography sx={{ width: '60%', flexShrink: 0 }} className="acc-header">
            Metrics
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableBody>
                  {rows.map(row => (
                    <TableRow key={row.name} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                      <TableCell component="th" scope="row">
                        {row.name}
                      </TableCell>
                      <TableCell align="right">{row.value}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Typography>
        </AccordionDetails>
      </Accordion>
    </>
  );
};

export default memo(MetricsDetails);
